import { CaseRecordType } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { Alert } from '@avantstay/backoffice-core'

import { recordTypeFromCaseForm } from './caseFormRecordType'
import { TaxonomyNatureOption } from './CaseTaxonomy.types'

/**
 * Guards taxonomy-case submissions: the cascade must have resolved a nature
 * (which carries the taxonomyId), and the nature's caseForm must belong to a
 * record type the current form can persist — the edit forms are static, so a
 * cross-form reclassification would pair the wrong input with the taxonomyId.
 * Alerts and returns false otherwise.
 */
export const validateTaxonomySelection = (
  nature: TaxonomyNatureOption | null | undefined,
  allowedRecordTypes: CaseRecordType[],
): nature is TaxonomyNatureOption => {
  if (!nature?.taxonomyId) {
    Alert.Error('Select the complete classification before saving.')
    return false
  }

  if (!allowedRecordTypes.includes(recordTypeFromCaseForm(nature.caseForm))) {
    Alert.Error(
      'The selected classification belongs to a different record type and cannot be saved from this form.',
    )
    return false
  }

  return true
}
